import { axiosClientPortalInstance, axiosInstance } from "./";

/** Client Satisfaction Survey (PROLINE-2998) — singular resource nested under an
 * event. The survey is resolved from `event_id` + caller scope, so there is no
 * `:id` in the path. Responses return the survey object directly under `data`
 * (or `null`). Criteria are `{ section, attribute_name, rating }`. */

// Client Portal — read the client's own survey / submit it.
export const getClientEventSatisfactionSurvey = (eventId) =>
  axiosClientPortalInstance.get(`/events/${eventId}/satisfaction_survey`);

export const submitClientEventSatisfactionSurvey = ({
  eventId,
  attributes_data,
  comments,
}) =>
  axiosClientPortalInstance.post(`/events/${eventId}/satisfaction_survey`, {
    attributes_data,
    comments,
  });

// Admin Portal — read-only view of the event's survey.
export const getAdminEventSatisfactionSurvey = (eventId) =>
  axiosInstance.get(`/events/${eventId}/satisfaction_survey`);
